import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { uploadsApi } from 'apis/uploads';
import { Table } from '../table/table';
export const AudioMessageFiles = () => {
    const { data, refetch, isLoading, isError } = uploadsApi.useReadAnnouncementsQuery();
    const numFiles = data === null || data === void 0 ? void 0 : data.data.uploads.length;
    return (_jsx(Page.Section, Object.assign({ title: `${numFiles !== null && numFiles !== void 0 ? numFiles : 0} audio message${numFiles === 1 ? '' : 's'}` }, { children: _jsx(Table, { type: "announcement", data: data, retry: refetch, isLoading: isLoading, isError: isError }) })));
};
